<div class="overflow-auto w-full h-full pb-20 bg-gray-50 font-prompt mx-auto">
  <div
    class="w-full bg-(--header-background) px-4 py-3 flex items-center justify-between sticky top-0 z-30 shadow-sm text-white select-none">
    <button type="button" (click)="goBack()"
      class="flex items-center text-white hover:opacity-80 active:scale-95 transition-all outline-none">
      <img src="icons/arrow_back_white.svg" alt="back" />
    </button>
    <h1 class="text-sm font-bold tracking-wide m-0">
      {{ currentLang === 'TH' ? 'รายละเอียดข่าว' : 'News Detail' }}
    </h1>
    <div class="w-6"></div>
  </div>

  <div *ngIf="notFound && !isLoading" class="px-4 pt-10 text-center">
    <p class="text-sm font-bold text-slate-700">
      {{ currentLang === 'TH' ? 'ไม่พบข่าวสาร' : 'News not found' }}
    </p>
    <button type="button" (click)="goBack()"
      class="mt-4 px-4 py-2 rounded-xl bg-amber-400 text-slate-900 text-xs font-bold">
      {{ currentLang === 'TH' ? 'กลับ' : 'Back' }}
    </button>
  </div>

  <div *ngIf="detail as d" class="pb-6">
    <button *ngIf="d.coverImageUrl" type="button" (click)="openZoom(d.coverImageUrl)"
      class="zoom-media w-full h-48 bg-slate-100 overflow-hidden border-0 p-0 cursor-zoom-in relative">
      <img [src]="d.coverImageUrl" [alt]="title" class="w-full h-full object-cover" />
      <span class="zoom-hint" aria-hidden="true">
        <img src="icons/search_slate.svg" alt="" class="w-3.5 h-3.5 invert" />
      </span>
    </button>

    <div class="px-4 pt-4 space-y-3">
      <div class="flex items-center gap-2 flex-wrap">
        <span *ngIf="d.pin"
          class="px-2 py-0.5 rounded-lg bg-amber-100 text-amber-700 text-[10px] font-bold">
          {{ currentLang === 'TH' ? 'ปักหมุด' : 'Pinned' }}
        </span>
        <span *ngIf="d.categoryName"
          class="px-2 py-0.5 rounded-lg bg-slate-100 text-slate-600 text-[10px] font-bold">
          {{ d.categoryName }}
        </span>
        <span *ngIf="!d.siteId"
          class="px-2 py-0.5 rounded-lg bg-sky-50 text-sky-700 text-[10px] font-bold">City Parking</span>
        <span *ngIf="d.siteId"
          class="px-2 py-0.5 rounded-lg bg-emerald-50 text-emerald-700 text-[10px] font-bold">
          {{ currentLang === 'TH' ? 'ประกาศจากลาน' : 'From lot' }}{{ d.siteName ? ' · ' + d.siteName : '' }}
        </span>
      </div>

      <h2 class="text-base font-extrabold text-slate-800 leading-snug">{{ title }}</h2>
      <p *ngIf="d.publishFrom" class="text-[11px] text-slate-400">{{ formatDate(d.publishFrom) }}</p>
      <p *ngIf="d.summary" class="text-sm text-slate-600 leading-relaxed">{{ d.summary }}</p>

      <div *ngIf="body" class="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed pt-1">
        {{ body }}
      </div>

      <div *ngIf="d.images?.length" class="pt-2">
        <h3 class="text-xs font-bold text-slate-500 mb-2">
          {{ currentLang === 'TH' ? 'รูปในเนื้อหา' : 'Gallery' }}
        </h3>
        <div class="grid grid-cols-2 gap-2">
          <button type="button" *ngFor="let img of d.images" (click)="openZoom(img.fullPath)"
            class="zoom-media relative aspect-[4/3] rounded-xl overflow-hidden border border-slate-100 bg-slate-50 p-0 cursor-zoom-in">
            <img [src]="img.fullPath" [alt]="img.caption || ''" class="w-full h-full object-cover" />
            <span class="zoom-hint" aria-hidden="true">
              <img src="icons/search_slate.svg" alt="" class="w-3.5 h-3.5 invert" />
            </span>
          </button>
        </div>
      </div>

      <button *ngIf="d.linkUrl" type="button" (click)="openLink()"
        class="w-full mt-2 py-3 rounded-2xl bg-amber-400 hover:bg-amber-500 text-slate-900 text-sm font-bold active:scale-[0.99] transition-all">
        {{ d.linkLabel || (currentLang === 'TH' ? 'เปิดลิงก์' : 'Open link') }}
      </button>

      <button *ngIf="d.sitePublicRef" type="button" (click)="openSitePage()"
        class="w-full mt-2 py-3 rounded-2xl bg-white border border-amber-200 text-amber-600 text-sm font-bold hover:bg-amber-50 active:scale-[0.99] transition-all flex items-center justify-center gap-2">
        <img src="/icons/marker-home.png" alt="" class="w-4 h-4" />
        {{ currentLang === 'TH' ? 'ดูหน้าลาน' : 'View parking lot' }}{{ d.siteName ? ' · ' + d.siteName : '' }}
      </button>
    </div>
  </div>
</div>

<app-image-viewer *ngIf="isViewerOpen" [images]="viewerImages" [startIndex]="viewerIndex"
  [lang]="currentLang" (closed)="closeZoom()"></app-image-viewer>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
